import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    delay: { type: Number, default: 1000 },
    storageKey: { type: String, default: 'dlr-popup-seen' }
  }

  connect() {
    if (this.seen) return
    this.openTimer = setTimeout(() => this.open(), this.delayValue)
  }

  disconnect() {
    clearTimeout(this.openTimer)
    // don't let Turbo cache an open dialog
    this.close()
  }

  open() {
    this.element.showModal()
    this.markSeen()
  }

  close() {
    if (this.element.open) this.element.close()
  }

  backdropClick(event) {
    if (event.target === this.element) this.close()
  }

  markSeen() {
    try {
      localStorage.setItem(this.storageKeyValue, '1')
    } catch (e) {
      // localStorage unavailable (Safari private mode) — popup just shows again
    }
  }

  get seen() {
    try {
      return localStorage.getItem(this.storageKeyValue) === '1'
    } catch (e) {
      return false
    }
  }
}
